// extracted by mini-css-extract-plugin
export default {"editButton":"EditModal_editButton__LhY37"};